// Parent component what coordinates what validation contents (warnings/errors/results) to show
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Loading } from "@ebsco-ui/ebsco-ui";
import ValidationResult from "./result";
import ValidationWarning from "./warning";
import MergeError from "../error";
import mapCodesToMessages from "../../../utils/merge/map-codes-to-messages";
import {
  getMergeValidateError,
  getMergeValidateErrors,
  getMergeValidateWarnings,
  getSourceUsername,
  validate
} from "../../../store/merge/validate";
import messages from "./validation-messages";
import { useIntl } from "react-intl";

const Validation = () => {
  const [warningsAccepted, acceptWarnings] = useState(false);
  const { formatMessage } = useIntl();
  const validationWarnings = useSelector(getMergeValidateWarnings) || [];
  const validationErrors = useSelector(getMergeValidateErrors) || [];
  const validationError = useSelector(getMergeValidateError);
  const username = useSelector(getSourceUsername);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(validate());
  }, [dispatch]);

  let warningMessageDescriptors = mapCodesToMessages(validationWarnings);
  let errorMessageDescriptors = mapCodesToMessages(validationErrors);

  /**
   * Some error and warning codes may not have a mapped message.
   * The error component should be displayed even if none of the error codes map to a message.
   * The warning component should ONLY display if we mapped at least one warning code to a message.
   */
  if (validationError || validationErrors.length > 0) {
    return <MergeError {...{ errorMessageDescriptors, username }} />;
  } else if (
    warningMessageDescriptors &&
    warningMessageDescriptors.length > 0 &&
    !warningsAccepted
  ) {
    return (
      <ValidationWarning
        {...{
          warningMessageDescriptors,
          username,
          onContinueWithMerge: () => acceptWarnings(true)
        }}
      />
    );
  } else if (username) {
    return <ValidationResult />;
  } else {
    return <Loading loadingMessage={formatMessage(messages.validatingMerge)} />;
  }
};

export { Validation };
export default Validation;
